import { Kaggle } from "@kaggle/sdk";
import { DefaultSessionSettingsActionKey } from "../../actions/ActionKeys";
import { DefaultSessionSettingsActions } from "../../actions/defaultSessionSettings";

type DefaultSessionSettings = Kaggle.Sdk.Kernels.Models.DefaultSessionSettings;

export function defaultSessionSettings(
  state: DefaultSessionSettings | null = null,
  action: DefaultSessionSettingsActions
): DefaultSessionSettings | null {
  switch (action.type) {
    case DefaultSessionSettingsActionKey.SET_DEFAULT_SESSION_SETTINGS:
      return action.payload.settings;
    default:
      return state;
  }
}
